import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { TournamentService } from '@/modules/tournament/api/services'
import { TOURNAMENT_QUERY_KEYS } from '@/modules/tournament/constants'

const useMutationDeleteTournament = () => {
	const queryClient = useQueryClient()

	return useMutation<void, Error, string>({
		mutationFn: (id) => TournamentService.deleteTournament(id),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: TOURNAMENT_QUERY_KEYS.TOURNAMENTS.ALL,
			})
			toast.success('ลบทัวร์นาเมนต์สำเร็จ')
		},
		onError: () => {
			toast.error('ลบทัวร์นาเมนต์ล้มเหลว')
		},
	})
}

export default useMutationDeleteTournament
